export default {
  data () {
    return {
      //  屏幕宽度
      clientWidth: 0,
      //  屏幕高度
      clientHeight: 0
    }
  },
  created () {
    //  计算 fontsize 的值
    const resetRecalc = () => {
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        const screenSize = this.getScreenSize();
        this.clientWidth = screenSize.clientWidth;
        this.clientHeight = screenSize.clientHeight;
      }, 50);
    }
    
    //  绑定事件
    window.addEventListener('orientationchange' in window ? 'orientationchange' : 'resize', resetRecalc.bind(this), false)
    document.addEventListener('DOMContentLoaded', resetRecalc.bind(this), false)
    if (!this.clientWidth) {
      resetRecalc();
    }
  },
  methods: {
    //  插入一个最顶层的 div 计算当前真实可视区宽高
    getScreenSize() {
      const __div = document.createElement('div');
      __div.style = 'width: 100%;height: 100%;position: fixed;top: 0;left: 0;z-index: 999999;'
      document.body.appendChild(__div);
      const ret = {
        clientWidth: __div.clientWidth,
        clientHeight: __div.clientHeight
      };
      __div.remove();
      return ret;
    }
  }
}
